<template>
  <main-content-layout :title="$gettext('SIMPLE_AGREEMENT')">
    <header-colapse-table
      :class="{ 'tw-mt-4': index != 0 }"
      @colapse="()=> {isShowDataWaste = !isShowDataWaste}"
      isWaste
    />
    <service-request-simple-agreement
      v-if="isShowDataWaste"
      :consumerUnit="consumerUnit"
      :protocol="protocol"
    />
    <header-colapse-table
      :class="{ 'tw-mt-4': index != 0 }"
      @colapse="()=> {isShowDataSigre = !isShowDataSigre}"
      isSigre
    />
    <service-request-simple-agreement-sigre
      v-if="isShowDataSigre"
      :consumerUnit="consumerUnit"
      :protocol="protocol"
    />
  </main-content-layout>
</template>
<script>
import ServiceRequestSimpleAgreement from './ServiceRequestSimpleAgreement.vue'
import ServiceRequestSimpleAgreementSigre from './ServiceRequestSimpleAgreementSigre.vue'
import { Component, Vue } from 'vue-property-decorator'
import MainContentLayout from '../../../Layout/MainContentLayout.vue'
import HeaderColapseTable from '../component/serviceRequestInvoice/HeaderColapseTable.vue'
@Component({
  name: 'ServiceRequestSimpleAgreementController',
  components: {
    ServiceRequestSimpleAgreement,
    ServiceRequestSimpleAgreementSigre,
    MainContentLayout,
    HeaderColapseTable
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestSimpleAgreementController extends Vue {
  isShowDataWaste = true;
  isShowDataSigre = false;
}
export default ServiceRequestSimpleAgreementController
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";
.table-header {
  background-color: #f1f1f1;
  margin: 30px;
}

.cell-values {
  display: flex;
  flex-direction: column;
}

.colapse-area {
  background-color: #5898aa;
  display: grid;
  grid-template-columns: 32% 32% 32% 4%;
}

.box-buttom {
  grid-column-start: 4;
  grid-column-end: 5;
  grid-row-start: 1;
  grid-row-end: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 35px;
}

.colapse {
  color: #fff;
  padding: 8px 20px;
}

.row-paint-colapse {
  background-color: #f1f1f1;
}

.index {
  border-radius: 25px;
  padding: 2px 10px;
  max-height: 25px;
}

.buttons-area {
  height: 35px;
  display: flex;
}

.index-table {
  width: 50%;
  display: flex;
  align-items: center;
  gap: 15px;
}

.rigth-buttons {
  width: 50%;
  display: flex;
  justify-content: right;
}

.sub-teble-btn {
  border: none;
  background-color: #fff;
  font-size: 18px !important;
  margin-left: 15px;
}

.top-area {
  background-color: #f1f1f1;
  display: flex;
  justify-content: space-around;
  padding: 17px 0;
}

.small-span {
  font-weight: 300;
}

.block-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
